import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e518744"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  viewBox: "0 0 50 50",
  class: "loading__spinner-inner"
}
const _hoisted_2 = ["stroke"]

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  ...{
  name: "Loading",
},
  __name: 'Loading',
  props: {
  /** Текст под спиннером */
  text: {
    type: String,
    default: "Идёт загрузка...",
  },
  /** Цвет спиннера */
  spinnerColor: {
    type: String,
    default: "#007bff", // Значение по умолчанию
  },
  /** Цвет текста */
  textColor: {
    type: String,
    default: undefined,
  },
  /** Размер спиннера (например, '40px' или '2.5rem') */
  size: {
    type: String,
    default: "60px",
  },
  /** Цвет оверлея (если fullscreen) */
  overlayColor: {
    type: String,
    default: "rgba(0, 0, 0, 0.05)",
  },
  /** Режим на весь экран */
  fullscreen: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["loading", { 'loading--fullscreen': __props.fullscreen }]),
    style: _normalizeStyle({ backgroundColor: __props.overlayColor })
  }, [
    _createElementVNode("div", {
      class: "loading__spinner",
      style: _normalizeStyle({ width: __props.size, height: __props.size })
    }, [
      (_openBlock(), _createElementBlock("svg", _hoisted_1, [
        _createElementVNode("circle", {
          class: "loading__spinner-circle",
          cx: "25",
          cy: "25",
          r: "20",
          fill: "none",
          stroke: __props.spinnerColor,
          "stroke-width": "5"
        }, null, 8, _hoisted_2)
      ]))
    ], 4),
    (__props.text)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "loading__text",
          style: _normalizeStyle({ color: __props.textColor })
        }, _toDisplayString(__props.text), 5))
      : _createCommentVNode("", true)
  ], 6))
}
}

})